import { TableFilterConfig, FilterFieldConfig } from 'hooks';

/**
 * Filter fields configuration for Site Management table
 */
export const SITE_FILTER_FIELDS: FilterFieldConfig[] = [
  { id: 'customerSiteId', type: 'text', label: 'Customer Site ID' },
  { id: 'name', type: 'text', label: 'Site Name' },
  { id: 'type', type: 'text', label: 'Type of Site' },
  { id: 'businessUnit', type: 'text', label: 'Business Unit' },
  { id: 'city', type: 'text', label: 'City' },
  { id: 'country', type: 'text', label: 'Country' },
  { id: 'countryRegion', type: 'text', label: 'Region' },
  { id: 'userName', type: 'text', label: 'Data Provider' },
  { id: 'status', type: 'text', label: 'Status' },
];

/**
 * Type for site filters object
 */
export interface SiteFilters {
  customerSiteId: string | null;
  name: string | null;
  type: string | null;
  businessUnit: string | null;
  city: string | null;
  country: string | null;
  countryRegion: string | null;
  userName: string | null;
  status: string | null;
}

/**
 * Creates the filter configuration for the Sites table
 * @param isActiveTab - Whether this is the active or inactive tab
 */
export const createSiteFilterConfig = (isActiveTab: boolean): TableFilterConfig<SiteFilters> => ({
  localStorageKey: `site-management-${isActiveTab ? 'activeTab' : 'inactiveTab'}-filters`,
  filterMode: 'column',
  fields: SITE_FILTER_FIELDS,
  displayNameMap: {
    customerSiteId: 'Customer Site ID',
    name: 'Site Name',
    type: 'Type of Site',
    businessUnit: 'Business Unit',
    city: 'City',
    country: 'Country',
    countryRegion: 'Region',
    userName: 'Data Provider',
    status: 'Status',
  },
  columnIdMap: {
    customerSiteId: 'customerSiteId',
    name: 'name',
    type: 'type',
    businessUnit: 'businessUnit',
    city: 'city',
    country: 'country',
    countryRegion: 'countryRegion',
    userName: 'userName',
    status: 'status',
  },
});

